import { Order } from '@/features/orders/types/app'
import { createContext } from 'use-context-selector'

interface IOrderListItemContext {
    order: Order
}

const OrderListItemContext = createContext<IOrderListItemContext>({
    order: {} as Order,
})

export default OrderListItemContext
